import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import moment from "moment";

class FeeReceiptModal extends Component {
    getLogoDataUrl = async (logoFile) => {
        if (!logoFile) return "";
        const url = `https://support.rizee.in/files/${logoFile}`;
        try {
            const res = await fetch(url, { credentials: "include" });
            if (!res.ok) return url;
            const blob = await res.blob();
            return await new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload  = () => resolve(reader.result);
                reader.onerror = () => resolve(url);
                reader.readAsDataURL(blob);
            });
        } catch {
            return url;
        }
    };

    buildRows(item, studentName, parentName, stateData, feeTypeName, paymentDetails) {
        console.log("item",item);
        
        const academicYear = stateData?.academic_year_text || "";
        const classAdm     = [stateData?.class_name, stateData?.admission_no].filter(Boolean).join(" / Adm No: ");
        const totalPaid    = (item.paid_amount || item.term_amount || 0).toLocaleString("en-IN");
        return [
            academicYear ? ["Academic Year",   academicYear]                                  : null,
            ["Student Name",                   studentName || "—"],
            parentName   ? ["Parent Name",     parentName]                                    : null,
            ["Class / Adm No",                 classAdm || "—"],
            feeTypeName  ? ["Fee Type",        feeTypeName]                                   : null,
            ["Total Paid",                     `₹${totalPaid} (${paymentDetails})`],
        ].filter(Boolean);
    }

    handlePrint = async () => {
        const { item, studentName, parentName, organisationProfile, getPaymentModes, stateData, feeTypeName } = this.props;
        const { logo } = organisationProfile || {};
        const logoUrl        = `https://support.rizee.in/files/${logo}`; // await this.getLogoDataUrl(logo);
        const orgName        = organisationProfile?.organisation_name || organisationProfile?.name || organisationProfile?.org_name || organisationProfile?.institute_name || "";
        const branchData     = (organisationProfile?.branch_wise_data || []).find(a => a.branch_id == stateData?.row_branch_id);
        const address        = branchData?.branch_wise_address || organisationProfile?.complete_address || "";
        const paymentMode    = (getPaymentModes || []).find(p => p.id == item.payment_mode_id);
        const paymentDetails = paymentMode?.payment_mode || "";
        const receiptDate    = item.paid_date ? moment.unix(item.paid_date).format("DD/MMM/YYYY") : "—";

        const rows    = this.buildRows(item, studentName, parentName, stateData, feeTypeName, paymentDetails);
        const rowsHtml = rows.map(([label, value]) => `
            <tr>
                <td style="padding:6px 0;font-size:13px;color:#555;width:220px">${label}</td>
                <td style="padding:6px 0;font-size:13px;color:#555;width:20px;text-align:center">:</td>
                <td style="padding:6px 0;font-size:13px;font-weight:700;color:#111">${value}</td>
            </tr>`).join("");

        const win = window.open("", "_blank", "width=800,height=700");
        win.document.write(`<html><head><title>Fee Receipt</title><style>
            *{margin:0;padding:0;box-sizing:border-box}
            body{font-family:Arial,sans-serif;padding:24px;color:#111;font-size:12px}
            .receipt-wrapper{width:700px;margin:0 auto;border:1.5px solid #333}
            .receipt-header{display:flex;align-items:center;gap:14px;padding:14px 18px 10px;border-bottom:1.5px solid #333}
            .hdr-logo{height:56px;width:auto;object-fit:contain;flex-shrink:0}
            .hdr-info{flex:1;text-align:center}
            .org-name{font-size:18px;font-weight:700;color:#111;margin-bottom:2px}
            .org-addr{font-size:11px;color:#555;line-height:1.5;margin:0 auto;max-width:500px}
            .receipt-title{display:flex;align-items:center;padding:10px 18px;border-bottom:1.5px solid #333}
            .rt-side{flex:1;font-size:11px;font-weight:400;color:#333;line-height:1.5}
            .rt-main{font-size:16px;font-weight:700;text-align:center}
            .receipt-body{padding:14px 18px}
            .receipt-footer{border-top:1.5px solid #333;padding:10px 18px}
            @media print{body{padding:8px}}
        </style></head><body>
            <div class="receipt-wrapper">
                <div class="receipt-header">
                    ${logoUrl ? `<img class="hdr-logo" src="${logoUrl}" />` : ""}
                    <div class="hdr-info">
                        <div class="org-name">${orgName}</div>
                        <div class="org-addr">${address}</div>
                    </div>
                </div>
                <div class="receipt-title">
                    <div class="rt-side" style="text-align:left">Receipt No: <strong>${item.payment_id || "—"}</strong><br/>Adm No: <strong>${stateData?.admission_no || "—"}</strong></div>
                    <div class="rt-main">Fee Receipt</div>
                    <div class="rt-side" style="text-align:right">Date: <strong>${receiptDate}</strong></div>
                </div>
                <div class="receipt-body">
                    <table style="width:100%;border-collapse:collapse">
                        <tbody>${rowsHtml}</tbody>
                    </table>
                </div>
                <div class="receipt-footer">
                    <div style="text-align:center;font-size:10px;color:#555;line-height:1.3">Note: Once a payment is made, it cannot be refunded. Thank You</div>
                    <div style="text-align:right;font-size:11px;font-weight:700;color:#333;margin-top:16px">School Stamp &amp; Sign</div>
                </div>
            </div>
            <script>
                ${logoUrl ? `var img=document.querySelector('img');if(img&&!img.complete){img.onload=function(){window.print();window.close();};img.onerror=function(){window.print();window.close()};}else{window.print();window.close();}` : `window.print();window.close();`}
            <\/script>
        </body></html>`);
        win.document.close();
        win.focus();
    };

    render() {
        const { show, onHide, item, studentName, parentName, organisationProfile, getPaymentModes, stateData, feeTypeName } = this.props;
        if (!item) return null;

        const { logo } = organisationProfile || {};
        const orgName        = organisationProfile?.organisation_name || organisationProfile?.name || organisationProfile?.org_name || organisationProfile?.institute_name || "";
        const branchData     = (organisationProfile?.branch_wise_data || []).find(a => a.branch_id == stateData?.row_branch_id);
        const address        = branchData?.branch_wise_address || organisationProfile?.complete_address || "";
        const paymentMode    = (getPaymentModes || []).find(p => p.id == item.payment_mode_id);
        const paymentDetails = paymentMode?.payment_mode || "";
        const receiptDate    = item.paid_date ? moment.unix(item.paid_date).format("DD/MMM/YYYY") : "—";
        const rows           = this.buildRows(item, studentName, parentName, stateData, feeTypeName, paymentDetails);

        return (
            <Modal show={show} onHide={onHide} size="lg" centered>
                <Modal.Header closeButton style={{ background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)", border: "none", padding: "14px 20px" }}>
                    <Modal.Title style={{ color: "#fff", fontWeight: 700, fontSize: 15 }}>Fee Receipt</Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ background: "#f8fafc", padding: "24px" }}>
                    <div style={{ border: "1.5px solid #333", background: "#fff", fontFamily: "Arial, sans-serif", maxWidth: 680, margin: "0 auto" }}>
                        {/* Header */}
                        <div style={{ display: "flex", alignItems: "flex-start", gap: 14, padding: "14px 18px 10px", borderBottom: "1.5px solid #333" }}>
                            {logo && (
                                <img src={`https://support.rizee.in/files/${logo}`} style={{ width: "auto", height: 60, objectFit: "contain", flexShrink: 0 }} alt="logo" />
                            )}
                            <div style={{ flex: 1, textAlign: "center" }}>
                                <div style={{ fontSize: 18, fontWeight: 700, color: "#111", marginBottom: 2 }}>{orgName}</div>
                                <div style={{ fontSize: 11, color: "#555", lineHeight: 1.5 }}>{address}</div>
                            </div>
                        </div>

                        {/* Title with Adm No (left) and Date (right) */}
                        <div style={{ display: "flex", alignItems: "center", padding: "10px 18px", borderBottom: "1.5px solid #333" }}>
                            <div style={{ flex: 1, textAlign: "left", fontSize: 11, fontWeight: 400, color: "#333", lineHeight: 1.5 }}>Receipt No: <strong>{item.payment_id || "—"}</strong><br />Adm No: <strong>{stateData?.admission_no || "—"}</strong></div>
                            <div style={{ fontSize: 16, fontWeight: 700, textAlign: "center" }}>Fee Receipt</div>
                            <div style={{ flex: 1, textAlign: "right", fontSize: 11, fontWeight: 400, color: "#333" }}>Date: <strong>{receiptDate}</strong></div>
                        </div>

                        {/* Data rows */}
                        <div style={{ padding: "14px 18px" }}>
                            {rows.map(([label, value]) => (
                                <div key={label} style={{ display: "flex", alignItems: "flex-start", padding: "6px 0", fontSize: 13, borderBottom: "1px solid #f0f0f0" }}>
                                    <div style={{ width: 220, color: "#555" }}>{label}</div>
                                    <div style={{ width: 20, textAlign: "center", color: "#555" }}>:</div>
                                    <div style={{ fontWeight: 700, color: "#111", flex: 1 }}>{value}</div>
                                </div>
                            ))}
                        </div>

                        {/* Footer */}
                        <div style={{ borderTop: "1.5px solid #333", padding: "10px 18px" }}>
                            <div style={{ textAlign: "center", fontSize: 10, color: "#555" }}>
                                Note: Once a payment is made, it cannot be refunded. Thank You
                            </div>
                            <div style={{ textAlign: "right", fontSize: 11, fontWeight: 700, color: "#333", marginTop: 16 }}>
                                School Stamp &amp; Sign
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer style={{ background: "#fff", borderTop: "1px solid #f3f4f6", gap: 10, justifyContent: "flex-end" }}>
                    <button
                        onClick={this.handlePrint}
                        style={{ background: "linear-gradient(135deg, #6366f1, #8b5cf6)", border: "none", borderRadius: 8, padding: "8px 22px", fontWeight: 700, fontSize: 13, color: "#fff", cursor: "pointer", display: "flex", alignItems: "center", gap: 7 }}
                    >
                        <i className="fas fa-print" /> Print Receipt
                    </button>
                    <button
                        onClick={onHide}
                        style={{ background: "#f3f4f6", border: "none", borderRadius: 8, padding: "8px 18px", fontWeight: 600, fontSize: 13, color: "#374151", cursor: "pointer" }}
                    >
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default FeeReceiptModal;
